import { IDocumentData } from '@app/transactions/components/upload-document/upload-document.component';

export const upload_transaction_model: Array<IDocumentData> = [
    {
        document_type: 'coupon',
        title: {
            pending: 'Tus comprobante de pago está en revisión.',
            approved: 'Tu comprobante de pago fue aprobado.',
            default: 'Sube fotos del comprobante de pago.'
        },
        why_go_up: `<p>Necesitamos que nos envíes una o más fotografías de la siguiente manera:</p>
            <p>En una hoja escribe “www.saldo.com.ar” y colocas sobre la misma el comprobante del pago y tu DNI.</p>`,
        documents_qty_min: 1,
        documents_qty_max: 5,
        gif: '',
        examples_document: [
            {
                url: '/assets/images/transaction-info/cupon/cupon-1-v1',
                urlFullScreen: '',
                condition: 'permitted'
            },
            {
                url: '/assets/images/transaction-info/cupon/cupon-2-v1',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/transaction-info/cupon/cupon-3-v1',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/transaction-info/cupon/cupon-4-v1',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/transaction-info/cupon/cupon-5-v1',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/transaction-info/cupon/cupon-6-v1',
                urlFullScreen: '',
                condition: 'restricted'
            },
            {
                url: '/assets/images/transaction-info/cupon/cupon-7-v1',
                urlFullScreen: '',
                condition: 'restricted'
            }
        ]
    }
];
